/*
NOTE: Custom care groups are not enabled in beta, it needs more UX/UI work to
document how this custom care groups should interact with the app
1) Does it need to work with adding people from where? PCM users DB?
2) Is this gonna need some permission tracking as well?
*/

import { Flex, Heading, Divider, Button } from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";
// import { useCareGroupsQuery } from "./api/useCareGroupsQuery";
import CareGroupCard from "./CareGroupCard";
// import { useCareGroupsDeleteMutation } from "./api/useCareGroupsMutation";

export default function CareGroupsPage() {
  const navigate = useNavigate();
  // const { data: careGroupsData } = useCareGroupsQuery();
  // const { mutate: careGroupsDeleteMutation } = useCareGroupsDeleteMutation();

  // const handleOnDelete = (groupId) => {
  //   careGroupsDeleteMutation(groupId);
  // };

  return (
    <Flex
      direction="column"
      padding="32px 32px 32px 32px"
      backgroundColor="rgba(250,250,250,1)"
    >
      <Heading level="1" children="Care Groups"></Heading>

      <Flex direction="row">
        <Flex direction="column">
          <CareGroupCard
            title="Health Providers"
            onViewClick={() => navigate("/user/hr/health-providers")}
            showEdit={false}
            showDelete={false}
          />
          <CareGroupCard
            title="Caregivers"
            onViewClick={() => navigate("/user/hr/caregivers")}
            showEdit={false}
            showDelete={false}
          />
          <CareGroupCard
            title="Minor Dependents"
            onViewClick={() => navigate("/user/hr/minor-dependents")}
            showEdit={false}
            showDelete={false}
          />
          {/* <Divider height="1px" size="small" orientation="horizontal" />
          <Flex alignItems={"center"}>
            <Heading level="5" children="Custom Groups" />
            <Button
              size="small"
              variation="primary"
              children="Add"
              onClick={() => navigate("/user/hr/care-groups/add")}
            />
          </Flex>
          {careGroupsData.map((careGroup) => (
            <CareGroupCard
              key={`cg_${careGroup.id}`}
              title={careGroup.groupName}
              onViewClick={() =>
                navigate(`/user/hr/care-groups/${careGroup.id}`)
              }
              onEditClick={() =>
                navigate(`/user/hr/care-groups/${careGroup.id}/edit`)
              }
              onDeleteClick={handleOnDelete.bind(this, careGroup.id)}
            />
          ))} */}
        </Flex>
      </Flex>
    </Flex>
  );
}
